export interface Country {
  code: string;
  name: string;
  dial: string;
  flag: string;
  mask?: string; // e.g. "### ###-##-##" where # is digit
}

// Phone masks for popular countries
const MASKS: Record<string, string> = {
  RU: "### ###-##-##",    // +7 999 123-45-67
  KZ: "### ###-##-##",    // +7 777 123-45-67
  UA: "## ###-##-##",     // +380 67 123-45-67
  BY: "## ###-##-##",     // +375 29 123-45-67
  UZ: "## ###-##-##",     // +998 90 123-45-67
  GE: "### ##-##-##",     // +995 555 12-34-56
  AM: "## ##-##-##",      // +374 77 12-34-56
  AZ: "## ###-##-##",     // +994 50 123-45-67
  KG: "### ##-##-##",     // +996 555 12-34-56
  TJ: "## ###-##-##",     // +992 90 123-45-67
  MD: "## ###-###",       // +373 69 123-456
  TM: "# ###-##-##",      // +993 6 123-45-67
  TH: "# ####-####",      // +66 8 1234-5678
  TR: "### ###-##-##",    // +90 555 123-45-67
  AE: "## ###-####",      // +971 50 123-4567 (9 цифр — нац. номер ОАЭ)
  US: "### ###-####",     // +1 555 123-4567
  CA: "### ###-####",     // +1 555 123-4567
  GB: "#### ######",      // +44 7911 123456
  DE: "### #######",      // +49 151 1234567
  FR: "# ## ## ## ##",    // +33 6 12 34 56 78
  IT: "### #######",      // +39 333 1234567
  ES: "### ## ## ##",     // +34 612 34 56 78
  IL: "##-###-####",      // +972 54-123-4567
  CN: "### #### ####",    // +86 138 1234 5678
  IN: "##### #####",      // +91 98765 43210
  JP: "##-####-####",     // +81 90-1234-5678
  KR: "##-####-####",     // +82 10-1234-5678
  BR: "## #####-####",    // +55 11 98765-4321
  AU: "### ### ###",      // +61 412 345 678
  EG: "## #### ####",     // +20 10 1234 5678
  PL: "### ### ###",      // +48 512 345 678
};

export const countries: Country[] = [
  { code: "AD", name: "Андорра", dial: "+376", flag: "🇦🇩" },
  { code: "AE", name: "ОАЭ", dial: "+971", flag: "🇦🇪" },
  { code: "AF", name: "Афганистан", dial: "+93", flag: "🇦🇫" },
  { code: "AG", name: "Антигуа и Барбуда", dial: "+1268", flag: "🇦🇬" },
  { code: "AI", name: "Ангилья", dial: "+1264", flag: "🇦🇮" },
  { code: "AL", name: "Албания", dial: "+355", flag: "🇦🇱" },
  { code: "AM", name: "Армения", dial: "+374", flag: "🇦🇲" },
  { code: "AO", name: "Ангола", dial: "+244", flag: "🇦🇴" },
  { code: "AQ", name: "Антарктида", dial: "+672", flag: "🇦🇶" },
  { code: "AR", name: "Аргентина", dial: "+54", flag: "🇦🇷" },
  { code: "AS", name: "Американское Самоа", dial: "+1684", flag: "🇦🇸" },
  { code: "AT", name: "Австрия", dial: "+43", flag: "🇦🇹" },
  { code: "AU", name: "Австралия", dial: "+61", flag: "🇦🇺" },
  { code: "AW", name: "Аруба", dial: "+297", flag: "🇦🇼" },
  { code: "AX", name: "Аландские острова", dial: "+358", flag: "🇦🇽" },
  { code: "AZ", name: "Азербайджан", dial: "+994", flag: "🇦🇿" },
  { code: "BA", name: "Босния и Герцеговина", dial: "+387", flag: "🇧🇦" },
  { code: "BB", name: "Барбадос", dial: "+1246", flag: "🇧🇧" },
  { code: "BD", name: "Бангладеш", dial: "+880", flag: "🇧🇩" },
  { code: "BE", name: "Бельгия", dial: "+32", flag: "🇧🇪" },
  { code: "BF", name: "Буркина-Фасо", dial: "+226", flag: "🇧🇫" },
  { code: "BG", name: "Болгария", dial: "+359", flag: "🇧🇬" },
  { code: "BH", name: "Бахрейн", dial: "+973", flag: "🇧🇭" },
  { code: "BI", name: "Бурунди", dial: "+257", flag: "🇧🇮" },
  { code: "BJ", name: "Бенин", dial: "+229", flag: "🇧🇯" },
  { code: "BL", name: "Сен-Бартелеми", dial: "+590", flag: "🇧🇱" },
  { code: "BM", name: "Бермуды", dial: "+1441", flag: "🇧🇲" },
  { code: "BN", name: "Бруней", dial: "+673", flag: "🇧🇳" },
  { code: "BO", name: "Боливия", dial: "+591", flag: "🇧🇴" },
  { code: "BQ", name: "Бонэйр, Синт-Эстатиус и Саба", dial: "+599", flag: "🇧🇶" },
  { code: "BR", name: "Бразилия", dial: "+55", flag: "🇧🇷" },
  { code: "BS", name: "Багамы", dial: "+1242", flag: "🇧🇸" },
  { code: "BT", name: "Бутан", dial: "+975", flag: "🇧🇹" },
  { code: "BV", name: "Остров Буве", dial: "+47", flag: "🇧🇻" },
  { code: "BW", name: "Ботсвана", dial: "+267", flag: "🇧🇼" },
  { code: "BY", name: "Беларусь", dial: "+375", flag: "🇧🇾" },
  { code: "BZ", name: "Белиз", dial: "+501", flag: "🇧🇿" },
  { code: "CA", name: "Канада", dial: "+1", flag: "🇨🇦" },
  { code: "CC", name: "Кокосовые острова", dial: "+61", flag: "🇨🇨" },
  { code: "CD", name: "ДР Конго", dial: "+243", flag: "🇨🇩" },
  { code: "CF", name: "ЦАР", dial: "+236", flag: "🇨🇫" },
  { code: "CG", name: "Республика Конго", dial: "+242", flag: "🇨🇬" },
  { code: "CH", name: "Швейцария", dial: "+41", flag: "🇨🇭" },
  { code: "CI", name: "Кот-д'Ивуар", dial: "+225", flag: "🇨🇮" },
  { code: "CK", name: "Острова Кука", dial: "+682", flag: "🇨🇰" },
  { code: "CL", name: "Чили", dial: "+56", flag: "🇨🇱" },
  { code: "CM", name: "Камерун", dial: "+237", flag: "🇨🇲" },
  { code: "CN", name: "Китай", dial: "+86", flag: "🇨🇳" },
  { code: "CO", name: "Колумбия", dial: "+57", flag: "🇨🇴" },
  { code: "CR", name: "Коста-Рика", dial: "+506", flag: "🇨🇷" },
  { code: "CU", name: "Куба", dial: "+53", flag: "🇨🇺" },
  { code: "CV", name: "Кабо-Верде", dial: "+238", flag: "🇨🇻" },
  { code: "CW", name: "Кюрасао", dial: "+599", flag: "🇨🇼" },
  { code: "CX", name: "Остров Рождества", dial: "+61", flag: "🇨🇽" },
  { code: "CY", name: "Кипр", dial: "+357", flag: "🇨🇾" },
  { code: "CZ", name: "Чехия", dial: "+420", flag: "🇨🇿" },
  { code: "DE", name: "Германия", dial: "+49", flag: "🇩🇪" },
  { code: "DJ", name: "Джибути", dial: "+253", flag: "🇩🇯" },
  { code: "DK", name: "Дания", dial: "+45", flag: "🇩🇰" },
  { code: "DM", name: "Доминика", dial: "+1767", flag: "🇩🇲" },
  { code: "DO", name: "Доминиканская Республика", dial: "+1809", flag: "🇩🇴" },
  { code: "DZ", name: "Алжир", dial: "+213", flag: "🇩🇿" },
  { code: "EC", name: "Эквадор", dial: "+593", flag: "🇪🇨" },
  { code: "EE", name: "Эстония", dial: "+372", flag: "🇪🇪" },
  { code: "EG", name: "Египет", dial: "+20", flag: "🇪🇬" },
  { code: "EH", name: "Западная Сахара", dial: "+212", flag: "🇪🇭" },
  { code: "ER", name: "Эритрея", dial: "+291", flag: "🇪🇷" },
  { code: "ES", name: "Испания", dial: "+34", flag: "🇪🇸" },
  { code: "ET", name: "Эфиопия", dial: "+251", flag: "🇪🇹" },
  { code: "FI", name: "Финляндия", dial: "+358", flag: "🇫🇮" },
  { code: "FJ", name: "Фиджи", dial: "+679", flag: "🇫🇯" },
  { code: "FK", name: "Фолклендские острова", dial: "+500", flag: "🇫🇰" },
  { code: "FM", name: "Микронезия", dial: "+691", flag: "🇫🇲" },
  { code: "FO", name: "Фарерские острова", dial: "+298", flag: "🇫🇴" },
  { code: "FR", name: "Франция", dial: "+33", flag: "🇫🇷" },
  { code: "GA", name: "Габон", dial: "+241", flag: "🇬🇦" },
  { code: "GB", name: "Великобритания", dial: "+44", flag: "🇬🇧" },
  { code: "GD", name: "Гренада", dial: "+1473", flag: "🇬🇩" },
  { code: "GE", name: "Грузия", dial: "+995", flag: "🇬🇪" },
  { code: "GF", name: "Французская Гвиана", dial: "+594", flag: "🇬🇫" },
  { code: "GG", name: "Гернси", dial: "+44", flag: "🇬🇬" },
  { code: "GH", name: "Гана", dial: "+233", flag: "🇬🇭" },
  { code: "GI", name: "Гибралтар", dial: "+350", flag: "🇬🇮" },
  { code: "GL", name: "Гренландия", dial: "+299", flag: "🇬🇱" },
  { code: "GM", name: "Гамбия", dial: "+220", flag: "🇬🇲" },
  { code: "GN", name: "Гвинея", dial: "+224", flag: "🇬🇳" },
  { code: "GP", name: "Гваделупа", dial: "+590", flag: "🇬🇵" },
  { code: "GQ", name: "Экваториальная Гвинея", dial: "+240", flag: "🇬🇶" },
  { code: "GR", name: "Греция", dial: "+30", flag: "🇬🇷" },
  { code: "GS", name: "Южная Георгия и Южные Сандвичевы Острова", dial: "+500", flag: "🇬🇸" },
  { code: "GT", name: "Гватемала", dial: "+502", flag: "🇬🇹" },
  { code: "GU", name: "Гуам", dial: "+1671", flag: "🇬🇺" },
  { code: "GW", name: "Гвинея-Бисау", dial: "+245", flag: "🇬🇼" },
  { code: "GY", name: "Гайана", dial: "+592", flag: "🇬🇾" },
  { code: "HK", name: "Гонконг", dial: "+852", flag: "🇭🇰" },
  { code: "HM", name: "Остров Херд и Острова Макдональд", dial: "+672", flag: "🇭🇲" },
  { code: "HN", name: "Гондурас", dial: "+504", flag: "🇭🇳" },
  { code: "HR", name: "Хорватия", dial: "+385", flag: "🇭🇷" },
  { code: "HT", name: "Гаити", dial: "+509", flag: "🇭🇹" },
  { code: "HU", name: "Венгрия", dial: "+36", flag: "🇭🇺" },
  { code: "ID", name: "Индонезия", dial: "+62", flag: "🇮🇩" },
  { code: "IE", name: "Ирландия", dial: "+353", flag: "🇮🇪" },
  { code: "IL", name: "Израиль", dial: "+972", flag: "🇮🇱" },
  { code: "IM", name: "Остров Мэн", dial: "+44", flag: "🇮🇲" },
  { code: "IN", name: "Индия", dial: "+91", flag: "🇮🇳" },
  { code: "IO", name: "Британская территория в Индийском океане", dial: "+246", flag: "🇮🇴" },
  { code: "IQ", name: "Ирак", dial: "+964", flag: "🇮🇶" },
  { code: "IR", name: "Иран", dial: "+98", flag: "🇮🇷" },
  { code: "IS", name: "Исландия", dial: "+354", flag: "🇮🇸" },
  { code: "IT", name: "Италия", dial: "+39", flag: "🇮🇹" },
  { code: "JE", name: "Джерси", dial: "+44", flag: "🇯🇪" },
  { code: "JM", name: "Ямайка", dial: "+1876", flag: "🇯🇲" },
  { code: "JO", name: "Иордания", dial: "+962", flag: "🇯🇴" },
  { code: "JP", name: "Япония", dial: "+81", flag: "🇯🇵" },
  { code: "KE", name: "Кения", dial: "+254", flag: "🇰🇪" },
  { code: "KG", name: "Киргизия", dial: "+996", flag: "🇰🇬" },
  { code: "KH", name: "Камбоджа", dial: "+855", flag: "🇰🇭" },
  { code: "KI", name: "Кирибати", dial: "+686", flag: "🇰🇮" },
  { code: "KM", name: "Коморы", dial: "+269", flag: "🇰🇲" },
  { code: "KN", name: "Сент-Китс и Невис", dial: "+1869", flag: "🇰🇳" },
  { code: "KP", name: "Северная Корея", dial: "+850", flag: "🇰🇵" },
  { code: "KR", name: "Южная Корея", dial: "+82", flag: "🇰🇷" },
  { code: "KW", name: "Кувейт", dial: "+965", flag: "🇰🇼" },
  { code: "KY", name: "Каймановы острова", dial: "+1345", flag: "🇰🇾" },
  { code: "KZ", name: "Казахстан", dial: "+7", flag: "🇰🇿" },
  { code: "LA", name: "Лаос", dial: "+856", flag: "🇱🇦" },
  { code: "LB", name: "Ливан", dial: "+961", flag: "🇱🇧" },
  { code: "LC", name: "Сент-Люсия", dial: "+1758", flag: "🇱🇨" },
  { code: "LI", name: "Лихтенштейн", dial: "+423", flag: "🇱🇮" },
  { code: "LK", name: "Шри-Ланка", dial: "+94", flag: "🇱🇰" },
  { code: "LR", name: "Либерия", dial: "+231", flag: "🇱🇷" },
  { code: "LS", name: "Лесото", dial: "+266", flag: "🇱🇸" },
  { code: "LT", name: "Литва", dial: "+370", flag: "🇱🇹" },
  { code: "LU", name: "Люксембург", dial: "+352", flag: "🇱🇺" },
  { code: "LV", name: "Латвия", dial: "+371", flag: "🇱🇻" },
  { code: "LY", name: "Ливия", dial: "+218", flag: "🇱🇾" },
  { code: "MA", name: "Марокко", dial: "+212", flag: "🇲🇦" },
  { code: "MC", name: "Монако", dial: "+377", flag: "🇲🇨" },
  { code: "MD", name: "Молдова", dial: "+373", flag: "🇲🇩" },
  { code: "ME", name: "Черногория", dial: "+382", flag: "🇲🇪" },
  { code: "MF", name: "Сен-Мартен", dial: "+590", flag: "🇲🇫" },
  { code: "MG", name: "Мадагаскар", dial: "+261", flag: "🇲🇬" },
  { code: "MH", name: "Маршалловы Острова", dial: "+692", flag: "🇲🇭" },
  { code: "MK", name: "Северная Македония", dial: "+389", flag: "🇲🇰" },
  { code: "ML", name: "Мали", dial: "+223", flag: "🇲🇱" },
  { code: "MM", name: "Мьянма", dial: "+95", flag: "🇲🇲" },
  { code: "MN", name: "Монголия", dial: "+976", flag: "🇲🇳" },
  { code: "MO", name: "Макао", dial: "+853", flag: "🇲🇴" },
  { code: "MP", name: "Северные Марианские острова", dial: "+1670", flag: "🇲🇵" },
  { code: "MQ", name: "Мартиника", dial: "+596", flag: "🇲🇶" },
  { code: "MR", name: "Мавритания", dial: "+222", flag: "🇲🇷" },
  { code: "MS", name: "Монтсеррат", dial: "+1664", flag: "🇲🇸" },
  { code: "MT", name: "Мальта", dial: "+356", flag: "🇲🇹" },
  { code: "MU", name: "Маврикий", dial: "+230", flag: "🇲🇺" },
  { code: "MV", name: "Мальдивы", dial: "+960", flag: "🇲🇻" },
  { code: "MW", name: "Малави", dial: "+265", flag: "🇲🇼" },
  { code: "MX", name: "Мексика", dial: "+52", flag: "🇲🇽" },
  { code: "MY", name: "Малайзия", dial: "+60", flag: "🇲🇾" },
  { code: "MZ", name: "Мозамбик", dial: "+258", flag: "🇲🇿" },
  { code: "NA", name: "Намибия", dial: "+264", flag: "🇳🇦" },
  { code: "NC", name: "Новая Каледония", dial: "+687", flag: "🇳🇨" },
  { code: "NE", name: "Нигер", dial: "+227", flag: "🇳🇪" },
  { code: "NF", name: "Остров Норфолк", dial: "+672", flag: "🇳🇫" },
  { code: "NG", name: "Нигерия", dial: "+234", flag: "🇳🇬" },
  { code: "NI", name: "Никарагуа", dial: "+505", flag: "🇳🇮" },
  { code: "NL", name: "Нидерланды", dial: "+31", flag: "🇳🇱" },
  { code: "NO", name: "Норвегия", dial: "+47", flag: "🇳🇴" },
  { code: "NP", name: "Непал", dial: "+977", flag: "🇳🇵" },
  { code: "NR", name: "Науру", dial: "+674", flag: "🇳🇷" },
  { code: "NU", name: "Ниуэ", dial: "+683", flag: "🇳🇺" },
  { code: "NZ", name: "Новая Зеландия", dial: "+64", flag: "🇳🇿" },
  { code: "OM", name: "Оман", dial: "+968", flag: "🇴🇲" },
  { code: "PA", name: "Панама", dial: "+507", flag: "🇵🇦" },
  { code: "PE", name: "Перу", dial: "+51", flag: "🇵🇪" },
  { code: "PF", name: "Французская Полинезия", dial: "+689", flag: "🇵🇫" },
  { code: "PG", name: "Папуа — Новая Гвинея", dial: "+675", flag: "🇵🇬" },
  { code: "PH", name: "Филиппины", dial: "+63", flag: "🇵🇭" },
  { code: "PK", name: "Пакистан", dial: "+92", flag: "🇵🇰" },
  { code: "PL", name: "Польша", dial: "+48", flag: "🇵🇱" },
  { code: "PM", name: "Сен-Пьер и Микелон", dial: "+508", flag: "🇵🇲" },
  { code: "PN", name: "Острова Питкэрн", dial: "+64", flag: "🇵🇳" },
  { code: "PR", name: "Пуэрто-Рико", dial: "+1787", flag: "🇵🇷" },
  { code: "PS", name: "Палестина", dial: "+970", flag: "🇵🇸" },
  { code: "PT", name: "Португалия", dial: "+351", flag: "🇵🇹" },
  { code: "PW", name: "Палау", dial: "+680", flag: "🇵🇼" },
  { code: "PY", name: "Парагвай", dial: "+595", flag: "🇵🇾" },
  { code: "QA", name: "Катар", dial: "+974", flag: "🇶🇦" },
  { code: "RE", name: "Реюньон", dial: "+262", flag: "🇷🇪" },
  { code: "RO", name: "Румыния", dial: "+40", flag: "🇷🇴" },
  { code: "RS", name: "Сербия", dial: "+381", flag: "🇷🇸" },
  { code: "RU", name: "Россия", dial: "+7", flag: "🇷🇺" },
  { code: "RW", name: "Руанда", dial: "+250", flag: "🇷🇼" },
  { code: "SA", name: "Саудовская Аравия", dial: "+966", flag: "🇸🇦" },
  { code: "SB", name: "Соломоновы Острова", dial: "+677", flag: "🇸🇧" },
  { code: "SC", name: "Сейшелы", dial: "+248", flag: "🇸🇨" },
  { code: "SD", name: "Судан", dial: "+249", flag: "🇸🇩" },
  { code: "SE", name: "Швеция", dial: "+46", flag: "🇸🇪" },
  { code: "SG", name: "Сингапур", dial: "+65", flag: "🇸🇬" },
  { code: "SH", name: "Остров Святой Елены", dial: "+290", flag: "🇸🇭" },
  { code: "SI", name: "Словения", dial: "+386", flag: "🇸🇮" },
  { code: "SJ", name: "Шпицберген и Ян-Майен", dial: "+47", flag: "🇸🇯" },
  { code: "SK", name: "Словакия", dial: "+421", flag: "🇸🇰" },
  { code: "SL", name: "Сьерра-Леоне", dial: "+232", flag: "🇸🇱" },
  { code: "SM", name: "Сан-Марино", dial: "+378", flag: "🇸🇲" },
  { code: "SN", name: "Сенегал", dial: "+221", flag: "🇸🇳" },
  { code: "SO", name: "Сомали", dial: "+252", flag: "🇸🇴" },
  { code: "SR", name: "Суринам", dial: "+597", flag: "🇸🇷" },
  { code: "SS", name: "Южный Судан", dial: "+211", flag: "🇸🇸" },
  { code: "ST", name: "Сан-Томе и Принсипи", dial: "+239", flag: "🇸🇹" },
  { code: "SV", name: "Сальвадор", dial: "+503", flag: "🇸🇻" },
  { code: "SX", name: "Синт-Мартен", dial: "+1721", flag: "🇸🇽" },
  { code: "SY", name: "Сирия", dial: "+963", flag: "🇸🇾" },
  { code: "SZ", name: "Эсватини", dial: "+268", flag: "🇸🇿" },
  { code: "TC", name: "Тёркс и Кайкос", dial: "+1649", flag: "🇹🇨" },
  { code: "TD", name: "Чад", dial: "+235", flag: "🇹🇩" },
  { code: "TF", name: "Французские Южные территории", dial: "+262", flag: "🇹🇫" },
  { code: "TG", name: "Того", dial: "+228", flag: "🇹🇬" },
  { code: "TH", name: "Таиланд", dial: "+66", flag: "🇹🇭" },
  { code: "TJ", name: "Таджикистан", dial: "+992", flag: "🇹🇯" },
  { code: "TK", name: "Токелау", dial: "+690", flag: "🇹🇰" },
  { code: "TL", name: "Восточный Тимор", dial: "+670", flag: "🇹🇱" },
  { code: "TM", name: "Туркменистан", dial: "+993", flag: "🇹🇲" },
  { code: "TN", name: "Тунис", dial: "+216", flag: "🇹🇳" },
  { code: "TO", name: "Тонга", dial: "+676", flag: "🇹🇴" },
  { code: "TR", name: "Турция", dial: "+90", flag: "🇹🇷" },
  { code: "TT", name: "Тринидад и Тобаго", dial: "+1868", flag: "🇹🇹" },
  { code: "TV", name: "Тувалу", dial: "+688", flag: "🇹🇻" },
  { code: "TW", name: "Тайвань", dial: "+886", flag: "🇹🇼" },
  { code: "TZ", name: "Танзания", dial: "+255", flag: "🇹🇿" },
  { code: "UA", name: "Украина", dial: "+380", flag: "🇺🇦" },
  { code: "UG", name: "Уганда", dial: "+256", flag: "🇺🇬" },
  { code: "UM", name: "Внешние малые острова США", dial: "+1", flag: "🇺🇲" },
  { code: "US", name: "США", dial: "+1", flag: "🇺🇸" },
  { code: "UY", name: "Уругвай", dial: "+598", flag: "🇺🇾" },
  { code: "UZ", name: "Узбекистан", dial: "+998", flag: "🇺🇿" },
  { code: "VA", name: "Ватикан", dial: "+379", flag: "🇻🇦" },
  { code: "VC", name: "Сент-Винсент и Гренадины", dial: "+1784", flag: "🇻🇨" },
  { code: "VE", name: "Венесуэла", dial: "+58", flag: "🇻🇪" },
  { code: "VG", name: "Британские Виргинские острова", dial: "+1284", flag: "🇻🇬" },
  { code: "VI", name: "Американские Виргинские острова", dial: "+1340", flag: "🇻🇮" },
  { code: "VN", name: "Вьетнам", dial: "+84", flag: "🇻🇳" },
  { code: "VU", name: "Вануату", dial: "+678", flag: "🇻🇺" },
  { code: "WF", name: "Уоллис и Футуна", dial: "+681", flag: "🇼🇫" },
  { code: "WS", name: "Самоа", dial: "+685", flag: "🇼🇸" },
  { code: "XK", name: "Косово", dial: "+383", flag: "🇽🇰" },
  { code: "YE", name: "Йемен", dial: "+967", flag: "🇾🇪" },
  { code: "YT", name: "Майотта", dial: "+262", flag: "🇾🇹" },
  { code: "ZA", name: "ЮАР", dial: "+27", flag: "🇿🇦" },
  { code: "ZM", name: "Замбия", dial: "+260", flag: "🇿🇲" },
  { code: "ZW", name: "Зимбабве", dial: "+263", flag: "🇿🇼" },
].map((c) => ({ ...c, mask: MASKS[c.code] }));
